var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 19.5C24 20.328 23.328 21 22.5 21H1.5C0.672 21 0 20.328 0 19.5V4.5C0 3.672 0.672 3 1.5 3H22.5C23.328 3 24 3.672 24 4.5V19.5Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.1,
    d: "M22.5 20.25H1.5C0.672 20.25 0 19.578 0 18.75V19.5C0 20.328 0.672 21 1.5 21H22.5C23.328 21 24 20.328 24 19.5V18.75C24 19.578 23.328 20.25 22.5 20.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3 15H12.75V17.25H3V15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.25 15H18V17.25H14.25V15Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18 11.25C19.6569 11.25 21 9.90685 21 8.25C21 6.59315 19.6569 5.25 18 5.25C16.3431 5.25 15 6.59315 15 8.25C15 9.90685 16.3431 11.25 18 11.25Z",
    fill: "#EACA44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.25 8.25C14.25 7.299 14.6152 6.441 15.1987 5.7795C14.715 5.44725 14.1315 5.25 13.5 5.25C11.8432 5.25 10.5 6.59325 10.5 8.25C10.5 9.90675 11.8432 11.25 13.5 11.25C14.1315 11.25 14.715 11.0527 15.1987 10.7205C14.6152 10.059 14.25 9.201 14.25 8.25Z",
    fill: "#EF4D4D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.ad04ae287b34cc560cde9d91ffab3027.svg";
export { ForwardRef as ReactComponent };